import React, { useState } from "react";
import "./Sidebar.css";
import { TbLayoutDashboardFilled } from "react-icons/tb";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { FiUsers, FiPieChart } from "react-icons/fi";
import { RiUserCommunityLine } from "react-icons/ri";
import { BsCalendarCheck } from "react-icons/bs";
import {
  HiOutlineCurrencyDollar,
  HiOutlineClipboardDocumentCheck,
} from "react-icons/hi2";
import { IoSettingsOutline } from "react-icons/io5";
import { TbClipboardText } from "react-icons/tb";
import { MdOutlinePersonOff } from "react-icons/md";


const Sidebar = ({ activePage, onMenuClick }) => {

  const menuItems = [
    { name: "Dashboard", icon: <TbLayoutDashboardFilled /> },
    { name: "Clients", icon: <HiOutlineUserGroup /> },
    { name: "Sub Vendors", icon: <HiOutlineUserGroup /> },
    { name: "Recruitment", icon: <FiUsers /> }, // parent group
    { name: "Employee", icon: <RiUserCommunityLine /> },
    { name: "Separation", icon: <MdOutlinePersonOff /> },
    { name: "Attendance", icon: <BsCalendarCheck /> },
    { name: "Payroll", icon: <HiOutlineCurrencyDollar /> },
    { name: "Leaves", icon: <TbClipboardText /> },
    { name: "Invoice", icon: <TbClipboardText /> },
    { name: "Reports", icon: <FiPieChart /> },
    { name: "Configuration", icon: <IoSettingsOutline /> },
  ];

  const userEmail = localStorage.getItem("userEmail");
  const isSpecialUser = userEmail === "nvguhan@wtilth.com";

  const filteredMenuItems = isSpecialUser
    ? menuItems.filter(item => ["Clients", "Recruitment", "Configuration"].includes(item.name))
    : menuItems;

  const [openRecruitment, setOpenRecruitment] = useState(true);
  const recruitmentSubmenu = [
    { key: "Recruitment Pipeline" },
    { key: "Candidate" },
    { key: "Onboarding" },
  ];

  // consider recruitment "active" if any of its subpages are active
  const isRecruitmentActive =
    activePage === "Recruitment" ||
    recruitmentSubmenu.some((s) => s.key === activePage);

  const handleRecruitParentClick = () => {
    setOpenRecruitment((v) => !v);
    // Navigate to Recruitment page whenever parent is clicked
    onMenuClick && onMenuClick("Recruitment");
  };

  const handleRecruitSubClick = (label) => {
    // "Recruitment Pipeline" should also route to the Recruitment page
    if (label === "Recruitment Pipeline") {
      onMenuClick && onMenuClick("Recruitment");
      return;
    }
    onMenuClick && onMenuClick(label);
  };

  return (
    <div className='sidebar'>
      <div className='company-logo'>
        <img src='/icons/Layer.png' alt='' className='company-logo-icon' />
        <div>
          <span className='company-name'></span>
        </div>
      </div>

      <ul className='menu' style={{ marginTop: "1px" }}>
        {filteredMenuItems.map((item, index) => {
          if (item.name !== "Recruitment") {
            return (
              <li
                key={index}
                className={`menu-item ${activePage === item.name ? "active" : ""
                  }`}
                onClick={() => onMenuClick && onMenuClick(item.name)}
              >
                <span className='menu-icon'>{item.icon}</span>
                <span className='menu-name'>{item.name}</span>
              </li>
            );
          }

          // Recruitment group
          return (
            <li key={index} className='menu-block'>
              <div
                className={`menu-item ${isRecruitmentActive ? "active" : ""}`}
                onClick={handleRecruitParentClick}
              >
                <span className='menu-icon'>{item.icon}</span>
                <span className='menu-name'>Recruitment</span>
                <span
                  className={`submenu-caret ${openRecruitment ? "open" : ""}`}
                />
              </div>

              {openRecruitment && (
                <ul className='submenu'>
                  {recruitmentSubmenu.map((s) => (
                    <li
                      key={s.key}
                      className={`submenu-item ${activePage === s.key ||
                        (s.key === "Recruitment Pipeline" &&
                          activePage === "Recruitment")
                        ? "active"
                        : ""
                        }`}
                      onClick={() => handleRecruitSubClick(s.key)}
                    >
                      <span className='submenu-branch' />
                      <span className='submenu-label'>{s.key}</span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>

      <button className='queries-button'>Queries</button>
    </div>
  );
};

export default Sidebar;
